import React, { useEffect, useState, useContext } from 'react'
import axios from 'axios'
import { useHistory, useParams, useLocation } from 'react-router'
import PageHeader from "../helper/PageHeader";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { authContext } from '../../context/AuthContext';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { NavLink } from "react-router-dom";
import Button from '@mui/material/Button';


function UserCertificateDetails (){

    const params = useParams()

    const history = useHistory()

    const [data, setData] = useState()

    const [email, setEmail] = useState('')

    const [alterEmail, setAlterEmail] = useState('')
    const [alterEmail2, setAlterEmail2] = useState('')

    const [requestStatus, setRequestStatus] = useState(false)

    const [error, setError] = useState(false)

    const location = useLocation();

    console.log('location', location)

    const [loading, setLoading] = useState(false)
    const userMain = useContext(authContext)

    const [checkedEmail, setCheckedEmail] = useState(false);
    const [checkedMail, setCheckedMail] = useState(false);
    const [addressSelection, setAddressSelection] = useState(() => {
        return location.state.employerName ? 'workAddress' : 'homeAddress'
    });

    const [otherAddressInfo, setOtherAddressInfo] = useState('')

    const locState = history.location.state
    const { certID, certDate } = locState
    const disableDownload = certID == '' || certID === null

    const handleChangeCheckBox = (event) => {
        setCheckedEmail(event.target.checked);
    }; 

    const handleChangeCheckBoxMail = (event) => {
        setCheckedMail(event.target.checked);
    }; 


    async function getData() {

        let res1 = await axios.get('/api/user/' + params.id);



        const result = res1.data
                // console.log("role trainee: " +  this.context.roles && this.context.roles.isTrainee);
                // grab initial fields from res
                console.log('result', result)
                let data = {
                    // isTrainee: this.context.roles && this.context.roles.isTrainee ? true : false,
                    username: result.user.username, //username will be the same as props.id
                    firstName: result.user.first_name,
                    title: result.user.title,
                    lastName: result.user.last_name,
                    middleName: result.user.middle_name,
                    suffix: result.user.suffix,
                    // suffix: result.user.suffix===null ? '' : result.user.suffix,
                    // credit: result.user.credit,
                    email: result.user.email,
                    birthdate: result.birthdate,
                    // alternateEmail: result.userExt.secondaryEMAIL,
                    trainingID: result.userExt.TRAINEEID,
                    // pesticideLicense: result.userExt.PESTICIDELICENSENUMBER,
                    // fertilizerLicense: result.userExt.FERTILIZERLICENSENUMBER,
                    // tookGIBMPTraining: result.userExt.TOOKGIBMPTRAINING,
                    // holdPesticideLicense: result.userExt.HOLDPESTICIDELICENSE,
                    // holdFertilizerLicense: result.userExt.HOLDFERTILIZERLICENSE,
                    // gender: result.userExt.GENDER,
                    homephone: result.userExt.HOMEPHONE,
                    workphone: result.userExt.WORKPHONE,
                    // ethnicity: result.userExt.ETHNICITY,
                    // age: result.userExt.AGE,
                    // jobTitle: result.userExt.JOBTITLE,
                    companyEmployed: result.userExt.companyEmployed,
                    mailingAddressIsWorkLocation: result.userExt.mailingAddressIsWorkLocation,
                    // homeLocID: result.userExt.homeLocationId,
                    // workLocID: result.userExt.workLocationId,
                    
                }
               setEmail(result.user.email)
                //console.log("SETTING FORM DATA", data)

                // if the homLoc is defined, then get the address and city fields from that part of the res
                if (result.homeLoc) {
                    data = {
                        ...data,
                        homeAddress: result.homeLoc.STREET,
                        homeCity: result.homeLoc.CITY,
                        homeState: result.homeLoc.STATECODE,
                        homeCounty:  result.homeLoc.COUNTYCODE,
                        // homeCounties: await getCounties(result.homeLoc.STATECODE),
                        homeZipcode: result.homeLoc.ZIPCODE
                    };
                    //console.log("SETTING FORM DATA AGAIN (homeLoc)", data)
                }

                // same as above but for workLoc
                if (result.workLoc) {
                    data = {
                        ...data,
                        employerName: result.workLoc.NAME,
                        workAddress: result.workLoc.STREET,
                        workCity: result.workLoc.CITY,
                        workState: result.workLoc.STATECODE ,
                        workCounty: result.workLoc.COUNTYCODE ,
                        // workCounties: await getCounties(result.workLoc.STATECODE),
                        workZipcode: result.workLoc.ZIPCODE
                    };
                    //console.log("SETTING FORM DATA AGAIN (workLoc)", data)
                }


                // sets form state based on data
  
        console.log('res1',res1)
  
        setData(data);
        console.log('data', data);
        setLoading(true)


    }

    useEffect(()=>{
        getData()

        return () => {
            setData({}); // This worked for me
          };
       
    }, []);

    const handleChange = event => {
        setEmail(event.target.value)
    }

    const handleChangeAlter1 = event => {
        setAlterEmail(event.target.value)
    }

    const handleChangeAlter2 = event => {
        setAlterEmail2(event.target.value)
    }

    const handleChangeAddressChange = (event) => {
        setAddressSelection(event.target.value)
      };

    const handleOtherAddressInfoChange = (event) => {
        setOtherAddressInfo(event.target.value)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('submit clicked to send the following data')

        // const element = "<html><body><div><p>test</p><<div>/body></html>"

        let mailAddressSelectedTemp = checkedMail ?
            addressSelection === 'homeAddress' ? 
            `<p> Home Phone :  ${data.homephone === undefined ? '' : data.homephone }</br>
            Home Address </br>
            Street Address : ${data.homeAddress === undefined ? '' : data.homeAddress}</br>
            City :  ${data.homeCity === undefined ? '' : data.homeCity}</br>
            County : ${data.homeCounty === undefined ? '' : data.homeCounty}</br>
            State :  ${data.homeState === undefined ? '' : data.homeState}</br>
            ZIP Code :  ${data.homeZipcode === undefined ? '' : data.homeZipcode}</br>
            ` 
            : 
            addressSelection === 'workAddress'
            ?
            `
            <p> Company Name :  ${data.employerName === undefined ? '' : data.employerName }</br>
            Company Phone :  ${data.workphone === undefined ? '' : data.workphone}</br>
            Work Address </br>
            Street Address :  ${data.workAddress === undefined ? '' : data.workAddress}</br>
            City :  ${data.workCity === undefined ? '' : data.workCity}</br>
            County : ${data.workCounty === undefined ? '' : data.workCounty}</br>
            State :  ${data.workState === undefined ? '' : data.workState}</br>
            ZIP Code :  ${data.workZipcode === undefined ? '' : data.workZipcode}</br>
            `
            :
            `Other Address: ${otherAddressInfo}`
          :
          '<p></p>'
        let emailAlternateTemp = checkedEmail ?
            `Alternate Email: ${alterEmail} </br>
            Alternate Email 2: ${alterEmail2} </br>`
            :
            '<p></p>'

        let new_element

        if (location.state.employerName){
            new_element = 
        `<html><body><div>

                    <p>Requested by (Employer): ${ location.state.employerName }  </br>
                    Send Certificate to : ${ email }</br>
                    Username :  ${data.username}</br>
                    Certificate ID: ${certID}</br>
                    Certificate Date: ${certDate}</br>
                    Full Name : ${data.firstName}  ${data.middleName} ${data.lastName}  ${data.suffix} </br>
                    Date of Birth :  ${data.birthdate}</br>
                    ${emailAlternateTemp}</br>
                    ${mailAddressSelectedTemp}</br>
                    </p>
                </div>

            </body>
        </html>
    `
        }else{
            new_element = 
            `<html><body><div>
                        <p> Username :  ${data.username}</br>

                        Full Name : ${data.firstName}  ${data.middleName} ${data.lastName}  ${data.suffix} </br>
                        Date of Birth :  ${data.birthdate}</br>

                        Certificate ID: ${certID}</br>
                        Certificate Date: ${certDate}</br>

                        Send Certificate to : ${ email }</br>
                        ${emailAlternateTemp}</br>
                        ${mailAddressSelectedTemp}</br>

                    </div>

                </body>
            </html>
        `

        }

        let subjectData = `Online Certificate Request for ${data.firstName} ${data.lastName}`

        try {
            await axios.post('/api/certificate/user/' + params.id, {
            email: email,
            html: new_element,
            subject: subjectData
        },
            {
                headers: { Authorization: userMain.accessToken }
            });
            setRequestStatus(true)
            setTimeout(() => setRequestStatus(false), 10000 );
        } catch {
            setError(true)
        }
    }
    const Popup = props => {
        return (
            <div>
                <br />
                <Alert severity={props.severity} onClose={props.onClose}>{props.text}</Alert>
            </div>
        )
    }

    const clickViewCertificate = () => {
        console.log('view clicked')
        let splitDate = certDate.split(' ')
        let [year, month, day] = splitDate[0].split('-')
        let formattedDate = month + '-' + day + '-' + year
        console.log('formatted date', formattedDate)
        history.push('/dashboard/downloadUserCertificate/' + params.username, {
            certID: certID,
            certDate: formattedDate
        } )
    }

    let username = JSON.parse(sessionStorage.user)

    return (
      <>
            { requestStatus === true && <Popup severity="success" text="Requested Certificate Successfully" onClose={() => setRequestStatus(false)   } />}
            { error === true && <Popup severity="error" text="Requested Certificate Failed Try Again" onClose={() => setError(false)   } />}
            <PageHeader
                    title={'Training Certificate Request'} 
                    actionButtons={
                        [
                        { label: "Request Certificate", disabled: !checkedEmail && !checkedMail  }                        ] 
                    }
                    cancel={history.goBack}
                /> 
            {
               !disableDownload
                ?
                <>
                    <Box mb={2}>
                    <Button variant="contained" color="primary" onClick={clickViewCertificate}>Download Certificate</Button>
                    </Box>
                </>
                :
                <p></p>
            }
            <ValidatorForm
                noValidate
                onSubmit={handleSubmit}
                onError={(errors) => console.log(errors)}
            >
               
                <p>
                    Certificates for online tests will be automatically emailed and mailed within 2 business days of passing the test. 
                    Please use this form only if you need a replacement or need your certificate emailed to a different address.
                </p>
                    {
                        loading
                        ?
                        <>
                            <> 
                                        <p>Certificate ID: {certID}</p>
                                        <p>Certificate Date: {certDate}</p>
                                        <FormGroup>
                                            <FormControlLabel control={
                                                <Checkbox checked={checkedEmail}
                                                onChange={handleChangeCheckBox}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                />} 
                                                label="Email PDF copy of Certificate" />
                                            <FormControlLabel control={<Checkbox 
                                                checked={checkedMail}
                                                onChange={handleChangeCheckBoxMail}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />} label="Mail Paper Certificate" />
                                        </FormGroup>
                                        
                                        <Grid item xs={12} sm={6}>
                                            <TextValidator
                                                label="Send Certificate to"
                                                onChange={handleChange}
                                                name="email"
                                                value={email}
                                                validators={['required', 'isEmail']}
                                                errorMessages={['this field is required', 'email is not valid']}
                                            />
                                            {
                                                checkedEmail
                                                ?
                                                <>
                                                    <TextValidator
                                                        label="Alternate Email 1"
                                                        onChange={handleChangeAlter1}
                                                        name="alterEmail"
                                                        value={alterEmail}
                                                        validators={[ 'isEmail']}
                                                        errorMessages={['email is not valid']}
                                                    />
                                                    <TextValidator
                                                        label="Alternate Email 2"
                                                        onChange={handleChangeAlter2}
                                                        name="alterEmail2"
                                                        value={alterEmail2}
                                                        validators={['isEmail']}
                                                        errorMessages={['email is not valid']}
                                                    />
                                                </>
                                                :
                                                <>
                                                
                                                </>
                                            }
                                            
                                        
                                        </Grid>

                                
                            
                            {
                                location.state
                                ? 
                                <p> Requested by (Employer):  {location.state.employerName}  </p>
                                :
                                <></>
                            }

                            <p> Username :  {data.username}</p>
                            <p> Full Name : {data.firstName}  {data.middleName} {data.lastName}  {data.suffix}  </p>
                            {
                                checkedMail
                                ?
                                <>
                                    <Grid item xs={12}>
                        
                                        <FormLabel component="legend"> Please Mail Certificate to : </FormLabel>
                                        <RadioGroup 
                                        row 
                                        aria-label="address" 
                                        name="address" 
                                        defaultValue= {location.state.employerName ? "workAddress" : "homeAddress" }
                                        onChange={handleChangeAddressChange}
                                        >
                                            {
                                                !location.state.employerName
                                                ?
                                                <FormControlLabel
                                                    id="homeAddress"
                                                    value="homeAddress"
                                                    // checked={!data.mailingAddressIsWorkLocation}
                                                    control={<Radio color="primary" />}
                                                    label= 'Home Address' 
                                                    name="homeAddress"
                                                />
                                                :
                                                <></>
                                            }
                                            
                                            <FormControlLabel
                                                id="workAddress"
                                                value="workAddress"
                                                // checked={data.mailingAddressIsWorkLocation}
                                                control={<Radio color="primary" />}
                                                label= 'Work Address'
                                                name="workAddress"
                                            />
                                            <FormControlLabel
                                                id="otherAddress"
                                                value="otherAddress"
                                                // checked={data.mailingAddressIsWorkLocation}
                                                control={<Radio color="primary" />}
                                                label= 'Other Address'
                                                name="otherAddress"
                                            />
                                        </RadioGroup>
                                    </Grid>
                                </>
                                :
                                <></>
                            }
                            {
                                checkedMail && !location.state.employerName
                                ?
                                <>
                                    <p>
                                    Is your address correct ? <NavLink to={`/dashboard/user/`  + username.username} activeClassName="active-tab" className="sub-navlink">Change Here</NavLink>
                                    </p>
                                </>
                                :
                                <></>
                            }                            {
                                checkedMail 
                                ?
                                <>
                               
                                {
                                    addressSelection === 'homeAddress'
                                    ?
                                    <>
                                        <div>
                                        <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                                            <h3 className="page-heading"> Home Information </h3>
                                        </Box>
                                        </div>

                                        <p> Home Phone :  {data.homephone}</p>

                                        <p> Home Address </p>

                                        <p> Street Address :  {data.homeAddress}</p>
                                        <p> City :  {data.homeCity}</p>
                                        <p> County : {data.homeCounty}</p>
                                        <p> State :  {data.homeState}</p>
                                        <p> ZIP Code :  {data.homeZipcode}</p>
                                    </>
                                    :
                                    <>
                                        {
                                            addressSelection === 'workAddress'
                                            ?
                                            <>
                                                <div>
                                                    <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                                                        <h3 className="page-heading"> Work Information </h3>
                                                    </Box>
                                                </div>

                                                <p> Company Name :  {data.employerName}</p>
                                                <p> Company Phone :  {data.workphone}</p>
                                                <p> Work Address </p>

                                                <p> Street Address :  {data.workAddress}</p>
                                                <p> City :  {data.workCity}</p>
                                                <p> County : {data.workCounty}</p>
                                                <p> State :  {data.workState}</p>
                                                <p> ZIP Code :  {data.workZipcode}</p>
                                            </>
                                            :
                                            <>
                                                <Box
                                                    sx={{
                                                        width: 500,
                                                        maxWidth: '100%',
                                                    }}
                                                >
                                                    <TextValidator
                                                        label="Other Address"
                                                        onChange={handleOtherAddressInfoChange}
                                                        name="otherAddress"
                                                        id="otherAddress"
                                                        type="text"
                                                        value={otherAddressInfo}
                                                        validators={['required']}
                                                        errorMessages={['Other Address is required']}
                                                        fullWidth
                                                        required
                                                    />
                                                </Box>
                                            </>
                                        }
                                    </>
                                }
                                    


                                    
                                </>
                                :
                                <></>
                            }

                            
                            
                            
                            </>
                        </>
                        :
                        <>
                        </>
                    }
            </ValidatorForm>
      </>
       
    );
}

export default UserCertificateDetails;


